import produce from 'immer'
import constants from 'constants/tags'

const initialState = {
  tags: [],
  fetching: false,
  doneFetching: false,
  fetchError: ''
}

export default produce((draft, action) => {
  switch (action.type) {
    case constants.FETCH_TAGS_REQUEST:
      draft.fetching = true
      break
    case constants.FETCH_TAGS_SUCCESS:
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = ''
      draft.tags = action.tags
      break
    case constants.FETCH_TAGS_FAILURE:
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = action.errorMessage
      break
  }
}, initialState)
